import { render } from "./AquacredCredential.vue?vue&type=template&id=068b5dc2"
import script from "./AquacredCredential.vue?vue&type=script&lang=js"
export * from "./AquacredCredential.vue?vue&type=script&lang=js"

import "./AquacredCredential.vue?vue&type=style&index=0&id=068b5dc2&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__